import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-hidden"
}
const _hoisted_2 = {
  key: 0,
  class: "grid grid-flow-col gap-16"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "mb-10"
}
const _hoisted_6 = {
  key: 1,
  class: "relative"
}
const _hoisted_7 = { class: "absolute inset-x-0 bottom-0 pb-70 px-gutter text-center z-1" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 2,
  class: "mb-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CMSLinkHandler = _resolveComponent("CMSLinkHandler")!
  const _component_MediaHandler = _resolveComponent("MediaHandler")!
  const _component_IndicatorsForNativeHorizontalScroll = _resolveComponent("IndicatorsForNativeHorizontalScroll")!

  return (_ctx.content.tiles.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (!_ctx.showCarousel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.tiles, (section) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: section.title,
                  class: "relative w-full",
                  style: _normalizeStyle(_ctx.textColorClass)
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-center absolute inset-x-0 bottom-0 z-3 mx-auto pb-30 px-gutter w-2/3 text-current-color md:px-0 md:pb-80", {width: 100 / _ctx.content.tiles.length + '%'}])
                  }, [
                    (section.model.subheading)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: "o-text-caption uppercase m-0",
                          innerHTML: section.model.subheading
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    (section.model.title)
                      ? (_openBlock(), _createElementBlock("h2", {
                          key: 1,
                          class: "mb-10",
                          innerHTML: section.model.title
                        }, null, 8, _hoisted_4))
                      : _createCommentVNode("", true),
                    (section.model.text)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(section.model.text), 1))
                      : _createCommentVNode("", true),
                    (section.model.link)
                      ? (_openBlock(), _createBlock(_component_CMSLinkHandler, {
                          key: 3,
                          class: "mt-15",
                          "link-block": section.model.link,
                          "style-as-button": !_ctx.content.alternativeLinkStyle
                        }, null, 8, ["link-block", "style-as-button"]))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createVNode(_component_MediaHandler, {
                    "media-block": section.model.media,
                    "media-aspect-ratio": _ctx.aspectRatioWithoutCarousel,
                    "video-disable-on-mobile": _ctx.content.disableVideoOnMobile
                  }, null, 8, ["media-block", "media-aspect-ratio", "video-disable-on-mobile"])
                ], 4))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.showCarousel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "c-scroll-bar-hide overflow-x-scroll grid grid-flow-col gap-16 relative",
                style: _normalizeStyle(_ctx.textColorClass)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.tiles, (section) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: section.title,
                    class: "min-w-screen-80 flex-no-shrink relative"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      (section.model.subheading)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "o-text-caption uppercase m-0",
                            innerHTML: section.model.subheading
                          }, null, 8, _hoisted_8))
                        : _createCommentVNode("", true),
                      (section.model.title)
                        ? (_openBlock(), _createElementBlock("h2", {
                            key: 1,
                            class: "mb-10",
                            innerHTML: section.model.title
                          }, null, 8, _hoisted_9))
                        : _createCommentVNode("", true),
                      (section.model.text)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(section.model.text), 1))
                        : _createCommentVNode("", true),
                      (section.model.link)
                        ? (_openBlock(), _createBlock(_component_CMSLinkHandler, {
                            key: 3,
                            class: "mt-15",
                            "link-block": section.model.link,
                            "style-as-button": !_ctx.content.alternativeLinkStyle
                          }, null, 8, ["link-block", "style-as-button"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_MediaHandler, {
                      "media-block": section.model.media,
                      "media-aspect-ratio": _ctx.aspectRatioWithCarousel,
                      "video-disable-on-mobile": _ctx.content.disableVideoOnMobile,
                      class: "w-full h-full"
                    }, null, 8, ["media-block", "media-aspect-ratio", "video-disable-on-mobile"])
                  ]))
                }), 128))
              ], 4),
              _createVNode(_component_IndicatorsForNativeHorizontalScroll, {
                "quantity-off-scroll-elements": _ctx.content.tiles.length
              }, null, 8, ["quantity-off-scroll-elements"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}